import React, { useState, useEffect } from 'react';
import styled from '@emotion/styled';
import { Box, Button, Input, MenuItem, Select, TextField, Typography } from '@mui/material';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // Import Quill's CSS
import { createTestimonials, getSinglePod, getSingleProduct, updateSinglePod, updateSingleProduct } from '../Service/api';
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom';
import DOMPurify from 'dompurify';

const Heading = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 20px;
`;

const ArabicWrapper = styled.div`
  direction: rtl;
`;

const ArabicHeading = styled.h4`
  font-family: 'Arabic Font', Arial, sans-serif;
  text-align: right;
`;

const EnglishHeading = styled.h4`
  display: flex;
  justify-content: start;
`;

const RichTextEditorWrapper = styled(Box)`
  margin-top: 20px;
  .ql-container {
    border: 1px solid #ccc;
    min-height: 200px;
    text-align: right; /* Align the Arabic text inside the editor to the right */
  }
`;

const Content = styled(Box)`
  border: 1px solid rgba(0, 0, 0, 0.2);
  margin: 1vw;
  padding: 1vw;

  @media (max-width: 767px) {
    margin: 1vh;
    padding: 1vh;
  }
`;

const Btn = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: start;
  margin-top: 1vh;
  margin-bottom: 1vh;

  @media (max-width: 767px) {
    margin-top: 2vh;
    margin-bottom: 2vh;
  }
`;



const MobHeading = styled(Box)`
  display: flex;
  height: 20px
  justify-content: center;
  flex-direction: column;
  align-items: start;
`


const EditPodcast = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
  const [name, setName] = useState('');
  const [arname, setArname] = useState('');
  const [englishDescription, setEnglishDescription] = useState('');
  const [arabicDescription, setArabicDescription] = useState('');
  const [image, setImage] = useState('');
  const [content, setContent] = useState([]);
  let categoryMatchFound = false;
  const {paramssix} = useParams()

  

  const handleNameChange = (event) => {
    console.log(event.target.value);
    setName(event.target.value);
  };

  const handleArnameChange = (event) => {
    setArname(event.target.value)
  }

  const handleEnglishDescriptionChange = (content) => {
    setEnglishDescription(content);
  };

  const handleArabicDescriptionChange = (content) => {
    setArabicDescription(content);
  };

  const handleImageChange = (event) => {
    // Update the 'image' state with the selected file
    console.log(event.target.files[0]);
    setImage(event.target.files[0]);
  };


  useEffect(() => {
    const fetchContent = async () => {
      try {
        const result = await getSinglePod(paramssix);
        const singleContent = result.data;
        setName(singleContent.name);
        setArname(singleContent.arname);
        setEnglishDescription(singleContent.des);
        setArabicDescription(singleContent.ardes);
        setImage(singleContent.image)
        console.log(singleContent);
      } catch (error) {
        // Handle errors (e.g., show error message)
        console.error(error);
        // Optionally, show a toast message with an error notification
        toast.error('Error fetching content data.');
      }
    };

    fetchContent();
  }, [paramssix]);

  const handleSubmit = async (e) => {
    console.log(image);
    e.preventDefault();
    const formData = new FormData();
    formData.append('name', name);
    formData.append('arname', arname);
    formData.append('englishDescription', DOMPurify.sanitize(englishDescription));
    formData.append('arabicDescription', DOMPurify.sanitize(arabicDescription));
    formData.append('image', image);
    
    console.log(formData);
    try {
      const result = await updateSinglePod(formData, paramssix);
      if (result) {
        toast.success('Posted!')
      }else{
        toast.error('Not Posted')
      }
      console.log('Submit button clicked');
    } catch (error) {
      // Handle errors (e.g., show error message)
      console.error(error);
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 767);
    };

    window.addEventListener('resize', handleResize);

    // Clean up the event listener
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  if (typeof content === 'undefined') {
    return(
        <h1>Loading...</h1>
    )
  }

  

  return (
    <>
      {!isMobile && <Heading>
        <h3>Edit Podcast</h3>
        <Typography>
          <span style={{ fontWeight: 600 }}>Form</span> &gt;{' '}
          <span style={{ fontWeight: 300 }}>Edit Podcast</span>
        </Typography>
      </Heading>}
      {isMobile && <MobHeading>
        <h3>Edit Podcast</h3>
        <Typography>
          <span style={{ fontWeight: 600 }}>Podcast</span> &gt;{' '}
          <span style={{ fontWeight: 300 }}>Add Podcast</span>
        </Typography>
      </MobHeading>}
      <Content component='form' noValidate onSubmit={handleSubmit}>
        <RichTextEditorWrapper>
            <EnglishHeading>Name</EnglishHeading>
            <TextField style={{ width: '100%' }} value={name} onChange={handleNameChange} />
            <EnglishHeading>Slug</EnglishHeading>
            <TextField style={{ width: '100%' }} disabled />
            <ArabicWrapper>
            <ArabicHeading>اسم</ArabicHeading>
            <TextField style={{ width: '100%' }} value={arname} onChange={handleArnameChange}/>
            </ArabicWrapper>
            <EnglishHeading>Description</EnglishHeading>
            <ReactQuill value={englishDescription} onChange={handleEnglishDescriptionChange} />
            <ArabicWrapper>
            <ArabicHeading>الصفحه الأولى</ArabicHeading>
            <ReactQuill value={arabicDescription} onChange={handleArabicDescriptionChange} />
            </ArabicWrapper>
            <EnglishHeading>Image</EnglishHeading>
            <Input type="file" accept="image/*" onChange={handleImageChange} />
            <Btn>
            <Button style={{ color: 'white', width: '2vw', backgroundColor: '#2ab57d' }} type="submit">
                Submit
            </Button>
            </Btn>
        </RichTextEditorWrapper>
      </Content>
    </>
  );
};

export default EditPodcast;
